import { inject, injectable } from "inversify";
import "reflect-metadata";
import { IReceitaFederalService } from "./ReceitaFederalUseCase";
import { ContabilDITypes } from "@/services/contabil/types";
import type { IDashboardGateway } from "@/services/contabil/dashboard/gateways/DashboardGateway";

@injectable()
export default class ReceitaFederalService implements IReceitaFederalService {
  @inject(ContabilDITypes.DASHBOARD_GATEWAY)
  client!: IDashboardGateway;

  async buildPainelReceitaFederal() {
    const receitaFederalResponse = await this.client.getReceitaFederal();

    const empecilhoResponse = await this.client.getEmpecilhos();

    return {
      receitaFederalResponse,
      empecilhoResponse
    };
  }
}
